import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RequestBody, RequestResponse, ZenitEndpoint } from '../../models/request.model';
import { ZenitEvent } from '../../models/zenit-general.model';

import { ConfigService } from '@core/infrastructure/config/config.service';
import { configRequired } from '@core/infrastructure/http-requests/http-requests.service';
import { CorePlatformService } from '@core/infrastructure/platform/platform.service';

@Injectable()
export class ZenitEventApiService {
    constructor(
        private readonly http: HttpClient,
        private readonly configService: ConfigService,
        private readonly platformService: CorePlatformService,
    ) { }

    /**
     * Envía los eventos de Zenit al endpoint correspondiente.
     * @param event Objeto completo de evento de Zenit
     * @param endpoint Endpoint específico para el evento proporcionado
     */
    public postEvent$(event: ZenitEvent, endpoint: ZenitEndpoint): Observable<RequestResponse> {
        if (this.platformService.isBrowser()) {
            const url: string = this.getZenitEndpoint(endpoint);

            const body: RequestBody<typeof event> = {
                records: [{
                    value: event,
                }],
            };

            return this.http.post<RequestResponse>(url, body);
        }
    }

    /**
     * Genera la url completa para realizar una petición de Zenit a partir del endpoint proporcionado.
     * @param endpoint Endpoint del evento específico
     */
    // eslint-disable-next-line no-secrets/no-secrets
    // @ConfigRequired<ZenitEventApiService, Error>(new Error('Configuration not found'))
    private getZenitEndpoint(endpoint: ZenitEndpoint): string {
        if (configRequired(this.configService.config)) {
            return `${this.configService.getConfigUrl<string>('baseUrl')}/integration/zenit/topics/meccano.md.pro.store.${endpoint}`;
        }
    }
}
